import Avatar from "./Avatar.vue";
import Checkbox from "./Checkbox.vue";
import ColorInput from "./ColorInput.vue";
import Combobox from "./Combobox.vue";
import DateInput from "./DateInput.vue";
import Field from "./Field.vue";
import FileInput from "./FileInput.vue";
import FontPicker from "./FontPicker.vue";
import Input from "./Input.vue";
import Label from "./Label.vue";
import NumberInput from "./NumberInput.vue";
import RadioGroup from "./RadioGroup.vue";
import RadioItem from "./RadioItem.vue";
import Select from "./Select.vue";
import Switcher from "./Switcher.vue";
import Textarea from "./Textarea.vue";
import TimeInput from "./TimeInput.vue";
import Toggle from "./Toggle.vue";

export type { ComboboxOption } from "./Combobox.vue";
export type { SelectOption } from "./Select.vue";
export type { SwitcherMode } from "./Switcher.vue";

export default {
  Avatar,
  Checkbox,
  ColorInput,
  Combobox,
  DateInput,
  Field,
  FileInput,
  FontPicker,
  Input,
  Label,
  NumberInput,
  RadioGroup,
  RadioItem,
  Select,
  Switcher,
  Textarea,
  TimeInput,
  Toggle,
};
